import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    scrollContentContainer: {
        justifyContent: "center",
        flexGrow: 1
    },
    container: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    forgotPasswordContainer: {
        alignItems: "center"
    },
    switchersContainer: {
        position: "absolute",
        flexDirection: "row"
    },
    guestButtonContainer: {
        alignItems: "center"
    },
    formContainer: {
        maxWidth: 400,
        width: "100%"
    },
    logo: {
        height: 150,
        width: 150
    }
});

export default stylesheet;
